import { indexData } from '@/mocks/home';

export default function SectionIndex() {
  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-50" style={{ scrollMarginTop: '4rem' }}>
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-xl md:text-2xl lg:text-3xl text-foreground-950 mb-2">
            吃瓜索引
          </h2>
          <p className="text-sm text-foreground-500">按板块快速浏览你最关心的吃瓜内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexData.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 group-hover:bg-primary-100 transition-colors">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-sm text-foreground-950">{item.title}</h3>
                  <span className="text-xs text-foreground-400">{item.count} 篇内容</span>
                </div>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
          <div className="bg-secondary-50 rounded-xl p-5 border border-secondary-200 flex flex-col items-center justify-center text-center cursor-pointer hover:bg-secondary-100 transition-colors">
            <i className="ri-add-line text-2xl text-secondary-500 mb-2"></i>
            <p className="text-sm font-medium text-secondary-700">更多板块</p>
            <p className="text-xs text-secondary-500">持续更新中</p>
          </div>
        </div>
      </div>
    </section>
  );
}